import { useCallback } from 'react'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import { ColumnDef, createColumnHelper } from '@tanstack/react-table'

import TSTable from 'components/Tanstack'
import { useTableUtils } from 'hooks/useTableUtils'
import { useCorporateContactsStore } from 'store/corporateContacts'
import {
  CorporateContactsDataTypes,
  CorporateContactsModalActionsTypes,
} from 'types/corporateContacts'

export const useCorporateContactsTable = () => {
  const corporateContacts = useCorporateContactsStore(
    (state) => state.corporateContacts
  )

  const {
    selectedModal,
    selectedModalSet,
    selectedRowData,
    selectedRowDataSet,
  } = useTableUtils<CorporateContactsDataTypes, CorporateContactsModalActionsTypes>()

  const handleActionModalClose = useCallback(() => {
    selectedRowDataSet(null)
    selectedModalSet(null)
  }, [selectedRowDataSet, selectedModalSet])

  const columnHelper = createColumnHelper<CorporateContactsDataTypes>()
  const columns = [
    // columnHelper.accessor('titleName', {
    //   header: () => 'Title',
    //   cell: (info) => info.getValue() || '---',
    // }),
    columnHelper.accessor('firstName', {
      header: () => 'Firstname',
      cell: (info) => info.getValue() || '---',
    }),
    columnHelper.accessor('middleNames', {
      header: () => 'Middlename',
      cell: (info) => info.getValue() || '---',
    }),
    columnHelper.accessor('lastName', {
      header: () => 'Lastname',
      cell: (info) => info.getValue() || '---',
    }),
    columnHelper.accessor('email', {
      header: () => 'Email',
      cell: (info) => info.getValue() || '---',
    }),
    columnHelper.accessor('phone1', {
      header: () => 'Workphone',
      cell: (info) => info.getValue() || '---',
    }),
    columnHelper.accessor('mobile', {
      header: () => 'Mobile Number',
      cell: (info) => info.getValue() || '---',
    }),
    columnHelper.accessor('isPrimary', {
      header: () => 'Primary',
      cell: (info) => (info.getValue() ? 'Yes' : 'No'),
    }),
    columnHelper.accessor('isActive', {
      header: () => 'Active',
      cell: (info) => (info.getValue() ? 'Yes' : 'No'),
    }),
    columnHelper.display({
      id: 'actions',
      header: () => '',
      cell: ({ row }) => (
        <div className="flex gap-2 px-4">
          <TSTable.TableCellButton
            onClick={() => {
              selectedRowDataSet(row.original)
              selectedModalSet('corporate_contacts_update')
            }}
            label="Update"
            icon={faPencilAlt}
          />
        </div>
      ),
    }),
  ] as ColumnDef<CorporateContactsDataTypes>[]

  return {
    corporateContactsSelected: selectedRowData,
    corporateContactsActionModal: selectedModal,
    corporateContactsTableData: corporateContacts,
    corporateContactsTableColumns: columns,
    handleCorporateContactsActionModalClose: handleActionModalClose,
  }
}
